module.exports = __webpack_public_path__ + "img/FactoryMap.1a2681e4.svg";